import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query-v4';
import { toast } from 'react-toastify';
import { handleApiFetchError } from '@scale/frontend-lib/api-fetch';

function isLocalEnvironment() {
  return typeof window !== 'undefined' && window.location.hostname === 'localhost';
}

function handleGlobalError(error: any) {
  const errorMessage =
    error?.message ??
    error?.toString() ??
    `Unknown ${error?.status ? `, status code: ${error.status}` : ''}}`;

  toast.error(`Error: ${errorMessage}`);
  handleApiFetchError(error);
}

const queryCache = new QueryCache({
  onError: handleGlobalError,
});

const mutationCache = new MutationCache({
  onError: handleGlobalError,
});

export const qmQueryClient = isLocalEnvironment()
  ? new QueryClient({
      queryCache,
      mutationCache,
      defaultOptions: {
        queries: {
          retry: 1,
          refetchOnWindowFocus: false,
        },
      },
    })
  : new QueryClient({
      queryCache,
      mutationCache,
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: false,
        },
      },
    });
